import React from "react";

export const ROLE_COLORS = [
  ["bg-violet-600", "Violet"], ["bg-sky-700", "Blue"], ["bg-cyan-600", "Cyan"],
  ["bg-emerald-600", "Green"], ["bg-lime-600", "Lime"], ["bg-amber-500", "Amber"],
  ["bg-orange-600", "Orange"], ["bg-red-600", "Red"], ["bg-pink-600", "Pink"],
];

export default function RoleColorPicker({ value, onChange, disabled, label = "Role color" }) {
  return <div role="group" aria-label={label} className="flex flex-wrap gap-1">
    {ROLE_COLORS.map(([color, name]) => <button key={color} type="button" disabled={disabled}
      aria-label={`${label}: ${name}`} aria-pressed={value === color} title={name}
      onClick={() => onChange(color)}
      className={`flex h-9 w-9 items-center justify-center rounded-lg border focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600 disabled:opacity-50 ${value === color ? "border-violet-500 bg-violet-50" : "border-transparent hover:bg-slate-100"}`}>
      <span className={`flex h-6 w-6 items-center justify-center rounded-full text-sm text-white ${color}`} aria-hidden="true">{value === color ? "✓" : ""}</span>
    </button>)}
  </div>;
}
